import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';

import { TimeWarningLog } from 'types';
import { useUserDateTime } from '../timezone/hooks/useUserDateTime';
import { formatInTimeZone } from 'date-fns-tz';

interface Props {
  timeWarningLog: TimeWarningLog[] | undefined;
}

const TimeWarningLogTable = ({ timeWarningLog }: Props) => {
  const { dateFormatWithZeros, timeFormat, timezone } = useUserDateTime();
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Analyzer Name</TableCell>
            <TableCell>Datetime</TableCell>
            <TableCell>Message</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {timeWarningLog?.map((item) => (
            <TableRow key={item.id}>
              <TableCell>{item.analyzer.name}</TableCell>
              <TableCell>
                {formatInTimeZone(
                  new Date(item.timestamp),
                  timezone,
                  `${dateFormatWithZeros} ${timeFormat}`
                )}
              </TableCell>
              <TableCell>Analyzer went above critical time threshold</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TimeWarningLogTable;
